import { TYPES } from '../../common/constants';

export const setAnnouncementFormData = payload => ({
  type: TYPES.SET_ANNOUNCEMENT_FORM_DATA,
  payload,
});


export const clearAnnouncementFormData = () => ({
  type:TYPES.CLEAR_ANNOUNCEMENT_FORM_DATA,
 })